import { ICellRendererParams } from 'ag-grid-community'
import { LinkIcon } from '@phosphor-icons/react/dist/ssr/Link'
import type { ProductStatus } from '@skop-app/lib-types'


export function LinkCellRenderer(params: ICellRendererParams<ProductStatus>) {
  const { value, colDef, node } = params

  const field = colDef?.field as string
  const finalValue = value || node?.aggData?.[field]
  if (!finalValue) return null

  return (
    <div className="flex h-full items-center">
      <div className="group flex cursor-pointer flex-row items-center space-x-1 rounded-md bg-neutral-50 py-0.5 pl-1 pr-1.5 leading-normal">
        <LinkIcon className="size-4 shrink-0" />
        <a href={finalValue} target="_blank" rel="noopener noreferrer" className="group-hover:underline">
          {finalValue}
        </a>
      </div>
    </div>
  )
}
